var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 89,
    viewBox: "0 0 177 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.5819 10H13.3268C11.8884 10 10.5608 10.7723 9.84976 12.0227L1.11548 27.3816C0.423111 28.5991 0.41798 30.0901 1.10195 31.3123L9.85469 46.9534C10.5619 48.2172 11.8971 49 13.3453 49H30.5634C32.006 49 33.3369 48.2232 34.0463 46.9671L42.88 31.3262C43.5744 30.0968 43.5691 28.5925 42.8663 27.368L34.0511 12.0089C33.3379 10.7663 32.0146 10 30.5819 10Z",
    fill: "#C9C2EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M79.186 0H68.7553C67.3554 0 66.0573 0.731905 65.3327 1.92979L60.2422 10.3458C59.4776 11.6099 59.472 13.1924 60.2276 14.4619L65.3369 23.0459C66.0581 24.2576 67.364 25 68.7741 25H79.1672C80.5715 25 81.8729 24.2636 82.5961 23.0598L87.7526 14.4759C88.5194 13.1995 88.5137 11.6028 87.7378 10.3319L82.6001 1.9158C81.8737 0.725873 80.5801 0 79.186 0Z",
    fill: "#C9C2EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M169.089 97.4376L157.306 63.4364C156.839 62.0895 155.691 61.0928 154.291 60.8201L118.969 53.9358C117.569 53.6629 116.13 54.1561 115.191 55.2302L91.202 82.6888C90.2576 83.7698 89.9648 85.274 90.4349 86.6303L102.206 120.596C102.674 121.947 103.828 122.946 105.232 123.215L141.123 130.099C142.535 130.37 143.983 129.862 144.917 128.769L168.351 101.346C169.273 100.267 169.554 98.7792 169.089 97.4376Z",
    fill: "#9486DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.6877996861fdec36c4eee065135de212.svg";
export { ForwardRef as ReactComponent };